import { createI18n } from 'vue-i18n'

import zh from './config/zh';
import en from './config/en';

const i18n = createI18n({
    locale : localStorage.getItem('local')||'zh',
    messages:{
        zh,en
    },
    globalInjection : true,
    legacy : false,
    fallbackLocale : 'zh'
})

export default i18n;